module.exports = __webpack_public_path__ + "img/cerade.51d14f3b.jpg";